// @core/api/endpoints/payment/create_payment_route.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePaymentRouteRequest,
  CreatePaymentRouteResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Create payment route
 * Creates a routing rule that maps transaction criteria (currency, country, BIN) to a specific provider.
 */
export async function CreatePaymentRoute(
  data: CreatePaymentRouteRequest,
  options?: RequestOptions
): Promise<CreatePaymentRouteResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-routes`;
  const requestOptions = options;
  return client.post<CreatePaymentRouteResponse>(requestPath, data, requestOptions);
}
